module.exports = __webpack_public_path__ + "img/Broken-Yolk.f478e2ee.png";